import { Language } from 'generated/mos/i18n'
import { Attachment, AttachmentIntent, MediaKind } from 'generated/mos/media'

import { defaultLanguage } from 'helpers/i18n'
import { getValuesForLanguage } from 'helpers/translatables'

export type MediaKindValidations = MediaKind

const FILE_TYPES = {
  AUDIO: [
    'm4a',
    'mp3',
  ],
  IMAGES: [
    'jpg',
    'jpeg',
    'png',
  ],
  VIDEO: [
    'mp4',
    'm4v',
  ],
  TEXT: [
    'txt',
    'md',
  ],
  PDF: [
    'pdf',
  ],
}

export const getAttachment = (
  attachments: ReadonlyArray<Attachment.Entity>,
  intent: AttachmentIntent,
  requestedLanguage: Language.Entity,
): Attachment.Entity | undefined => {
  const language = requestedLanguage || defaultLanguage()
  const matchesIntent = attachments.filter(attachment => attachment.intent === intent)
  const matches = getValuesForLanguage(matchesIntent, language) as any as ReadonlyArray<Attachment.Entity>

  return matches && matches.length ? matches[0] : undefined
}

export const isFileMediaKind = (file: File, mediaKind: MediaKindValidations): boolean => {
  const fileExtension = file.name.split('.').pop()!.toLowerCase()

  switch (mediaKind) {
    case 'MEDIA_KIND_AUDIO': {
      return FILE_TYPES.AUDIO.includes(fileExtension)
    }

    case 'MEDIA_KIND_RASTER_IMAGE': {
      return FILE_TYPES.IMAGES.includes(fileExtension)
    }

    case 'MEDIA_KIND_VIDEO': {
      return FILE_TYPES.VIDEO.includes(fileExtension)
    }

    case 'MEDIA_KIND_TEXT': {
      return FILE_TYPES.TEXT.includes(fileExtension)
    }

    case 'MEDIA_KIND_PDF': {
      return FILE_TYPES.PDF.includes(fileExtension)
    }

    case 'MEDIA_KIND_UNSPECIFIED':
    case 'MEDIA_KIND_BINARY':
    case 'MEDIA_KIND_VECTOR_IMAGE':
    default: {
      return false
    }
  }
};
